import { combineReducers } from 'redux';
import localForage from 'localforage';
import { userApi } from '@ports/internal-services/user/userApi';
import { subscriptionApi } from '@ports/internal-services/subscription/subscriptionApi';
import { userDetailsApi } from '@ports/internal-services/userDetails/userDetailsApi';
import { notificationSettingsApi } from '@ports/internal-services/notificationSettings/notificationSettingsApi';
import { notificationApi } from '@ports/internal-services/notification/notificationApi';
import { paymentApi } from '@ports/internal-services/payment/paymentApi';
import { userAddressApi } from '@ports/internal-services/userAddress/userAddressApi';
import { utilityConfigurationApi } from '@ports/internal-services/utilityConfiguration/utilityConfigurationApi';
import { assetApi } from '@ports/internal-services/asset/assetApi';
import { folderApi } from '@ports/internal-services/folder/folderApi';
import { commentApi } from '@ports/internal-services/comment/commentApi';
import { diaryApi } from '@ports/internal-services/diary/diaryApi';
import { commentLikesApi } from '@ports/internal-services/commentLikes/commentLikesApi';
import { likesApi } from '@ports/internal-services/likes/likesApi';
import { favoritesApi } from '@ports/internal-services/favorites/favoritesApi';
import { privateApi } from '@ports/internal-services/private/privateApi';
import { photoTagApi } from '@ports/internal-services/photoTag/photoTagApi';
import { recipeApi } from '@ports/internal-services/recipe/recipeApi';
import { momentsApi } from '@ports/internal-services/moments/momentsApi';
import { momentDiaryApi } from '@ports/internal-services/momentDiary/momentDiaryApi';
import { trashApi } from '@ports/internal-services/trash/trashApi';
import { memoriesApi } from '@ports/internal-services/memories/memoriesApi';
import { peopleApi } from '@ports/internal-services/people/peopleApi';
import { storageApi } from '@ports/internal-services/storage/storageApi';
import { tutorialApi } from '@ports/internal-services/tutorial/tutorialApi';
import { shareApi } from '@ports/internal-services/share/shareApi';
import { userRoleApi } from '@ports/internal-services/userRole/userRoleApi';
import { inviteApi } from '@ports/internal-services/invite/inviteApi';
import { groupApi } from '@ports/internal-services/group/groupApi';
import { customerAnalysisAdminApi } from '@ports/admin-services/customer-analysis/customerAnalysisAdminApi';
import { subscriptionAdminApi } from '@ports/admin-services/subscription/subscriptionAdminApi';
import { userManagementAdminApi } from '@ports/admin-services/user-management/userManagementAdminApi';
import { systemAdminApi } from '@ports/admin-services/system-admin/systemAdminApi';
import { securityAdminApi } from '@ports/admin-services/security/securityAdminApi';
import { analyticsAdminApi } from '@ports/admin-services/analytics/analyticsAdminApi';
import { financeAdminApi } from '@ports/admin-services/finance/financeAdminApi';
import { contentModerationApi } from '@ports/admin-services/content-moderation/contentModerationApi';
import { authStateSlice } from './authStateSlice';
import { sessionStateSlice } from './sessionStateSlice';
import { subscriptionStateSlice } from './subscriptionStateSlice';
import { userStateSlice } from './userStateSlice';
import { addressStateSlice } from './billingAddressStateSlice';
import { alertSlice } from './AlertStateSlice';
import { manualLoadingStateSlice } from './manualLoadingStateSlice';
import { commonStateSlice } from './commonStateSlice';
import { folderStateSlice } from './folderStateSlice';
import { filterStateSlice } from './filtersStateSlice';
import { favoriteViewSlice } from './favoriteViewSlice';
import { notificationStateSlice } from './notificationStateSlice';

const rootPersistConfig = {
  key: 'root',
  storage: localForage,
  keyPrefix: 'mykinships-persist-'
};

const rootReducer = combineReducers({
  [authStateSlice.name]: authStateSlice.reducer,
  [sessionStateSlice.name]: sessionStateSlice.reducer,
  [subscriptionStateSlice.name]: subscriptionStateSlice.reducer,
  [userStateSlice.name]: userStateSlice.reducer,
  [addressStateSlice.name]: addressStateSlice.reducer,
  [alertSlice.name]: alertSlice.reducer,
  [manualLoadingStateSlice.name]: manualLoadingStateSlice.reducer,
  [commonStateSlice.name]: commonStateSlice.reducer,
  [folderStateSlice.name]: folderStateSlice.reducer,
  [filterStateSlice.name]: filterStateSlice.reducer,
  [favoriteViewSlice.name]: favoriteViewSlice.reducer,
  [notificationStateSlice.name]: notificationStateSlice.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [subscriptionApi.reducerPath]: subscriptionApi.reducer,
  [userDetailsApi.reducerPath]: userDetailsApi.reducer,
  [notificationSettingsApi.reducerPath]: notificationSettingsApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
  [userAddressApi.reducerPath]: userAddressApi.reducer,
  [utilityConfigurationApi.reducerPath]: utilityConfigurationApi.reducer,
  [commentApi.reducerPath]: commentApi.reducer,
  [diaryApi.reducerPath]: diaryApi.reducer,
  [commentLikesApi.reducerPath]: commentLikesApi.reducer,
  [likesApi.reducerPath]: likesApi.reducer,
  [assetApi.reducerPath]: assetApi.reducer,
  [folderApi.reducerPath]: folderApi.reducer,
  [favoritesApi.reducerPath]: favoritesApi.reducer,
  [privateApi.reducerPath]: privateApi.reducer,
  [photoTagApi.reducerPath]: photoTagApi.reducer,
  [peopleApi.reducerPath]: peopleApi.reducer,
  [recipeApi.reducerPath]: recipeApi.reducer,
  [momentsApi.reducerPath]: momentsApi.reducer,
  [momentDiaryApi.reducerPath]: momentDiaryApi.reducer,
  [trashApi.reducerPath]: trashApi.reducer,
  [storageApi.reducerPath]: storageApi.reducer,
  [tutorialApi.reducerPath]: tutorialApi.reducer,
  [memoriesApi.reducerPath]: memoriesApi.reducer,
  [shareApi.reducerPath]: shareApi.reducer,
  [userRoleApi.reducerPath]: userRoleApi.reducer,
  [inviteApi.reducerPath]: inviteApi.reducer,
  [groupApi.reducerPath]: groupApi.reducer,
  [customerAnalysisAdminApi.reducerPath]: customerAnalysisAdminApi.reducer,
  [subscriptionAdminApi.reducerPath]: subscriptionAdminApi.reducer,
  [userManagementAdminApi.reducerPath]: userManagementAdminApi.reducer,
  [systemAdminApi.reducerPath]: systemAdminApi.reducer,
  [securityAdminApi.reducerPath]: securityAdminApi.reducer,
  [analyticsAdminApi.reducerPath]: analyticsAdminApi.reducer,
  [financeAdminApi.reducerPath]: financeAdminApi.reducer,
  [contentModerationApi.reducerPath]: contentModerationApi.reducer
});

export { rootPersistConfig, rootReducer };
